import { ShopOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import styled from 'styled-components';
import { type FormItemProps } from '../../FormItem';
import MarkdownField from '../../MarkdownField';
import { type SelectFieldProps } from '../../SelectField';
import { type TranslationDrawerProps } from '../../TranslatedInputField/TranslationDrawer';
import { StyledButtonContainer, StyledDiv } from '../../TranslatedMarkdownFieldArray/MarkdownFieldArray';
import {
    type DealershipTranslatedMarkdownDrawerProps,
    useDealershipTranslatedMarkdownDrawer,
} from './DealershipTranslatedMarkdownDrawer';

export type DealershipMarketInputFieldProps = Pick<
    SelectFieldProps,
    'options' | 'name' | 'disabled' | 'label' | 'itemProps'
> &
    Pick<DealershipTranslatedMarkdownDrawerProps, 'dealers'> &
    Pick<TranslationDrawerProps, 'languages'> & {
        isEdit?: boolean;
        isMultipleEntry?: boolean;
        tooltip?: FormItemProps['tooltip'];
    };

export const StyledButtonDiv = styled(StyledButtonContainer)`
    margin-bottom: 24px;
    margin-top: 30px;
`;
const DealershipTranslatedMarkdownField = ({
    name,
    dealers,
    disabled,
    languages,
    options,
    isEdit,
    isMultipleEntry,
    tooltip,
    ...props
}: DealershipMarketInputFieldProps) => {
    const drawer = useDealershipTranslatedMarkdownDrawer();

    // hide button completely when disable
    const button = disabled ? null : (
        <StyledButtonDiv>
            <Button
                icon={<ShopOutlined style={{ color: 'var(--ant-primary-color)' }} />}
                onClick={drawer.open}
                size="small"
                style={{ height: '100%' }}
                type="text"
            />
        </StyledButtonDiv>
    );

    return (
        <>
            <StyledDiv>
                <MarkdownField
                    label={props.label}
                    name={`${name}.defaultValue.defaultValue`}
                    required={false}
                    tooltip={tooltip}
                />
                {button}
            </StyledDiv>
            {drawer.render({ name, title: props.label, dealers, options })}
        </>
    );
};

export default DealershipTranslatedMarkdownField;
